import abTest from './items/abTest'
import ads from './items/ads'
import appLinks from './items/appLinks'
import auth from './items/auth'
import backend from './items/backend'
import cmp from './items/cmp'
import community from './items/commenting'
import cueLive from './items/cueLive'
import datawrapper from './items/datawrapper'
import date from './items/date'
import debug from './items/debug'
import dlApi from './items/dlApi'
import feedback from './items/feedback'
import formio from './items/formio'
import gamification from './items/gamification'
import gdpr from './items/gdpr'
import googleNews from './items/googleNews'
import hearken from './items/hearken'
import heimspiel from './items/heimspiel'
import iframe from './items/iframe'
import image from './items/image'
import jwplayer from './items/jwplayer'
import lotto from './items/lotto'
import metatags from './items/metatags'
import notifications from './items/notifications'
import oneSignal from './items/oneSignal'
import piano from './items/piano'
import plusLinkShare from './items/plusLinkShare'
import prolitteris from './items/prolitteris'
import podigee from './items/podigee'
import publication from './items/publication'
import recommendation from './items/recommendation'
import riddle from './items/riddle'
import schema from './items/schema'
import search from './items/search'
import sentry from './items/sentry'
import socialembeds from './items/socialembeds'
import sports from './items/sports'
import subscriptions from './items/subscriptions'
import tracking from './items/tracking'
import twitter from './items/twitter'
import ugc from './items/ugc'
import urlParams from './items/urlParams'
import usersnap from './items/usersnap'
import video from './items/video'
import vimeo from './items/vimeo'
import weather from './items/weather'
import webarchive from './items/webarchive'
import zattoo from './items/zattoo'
import leserreporter from './items/leserreporter'
import textToSpeech from './items/textToSpeech'
import articleSummary from './items/articleSummary'
import sectionSummary from './items/sectionSummary'
import questionWidget from './items/questionWidget'
import blickBites from './items/blickBites'
import chatbot from './items/chatbot'
import growthBook from './items/growthBook'
import aureus from './items/aureus'

import { ConfigFn, EnvVariables } from './types'

const localhostHTTPS = process.env.NEXT_PUBLIC_DEV_SERVER_HTTPS === 'true'
const useLocalhostStaticPages =
  process.env.NEXT_PUBLIC_USE_LOCALHOST_STATIC_PAGES === 'true'

const rawEnvVariables = {
  releaseVersion: process.env.NEXT_PUBLIC_RELEASE_VERSION ?? '',
  deploymentEnv: process.env.NEXT_PUBLIC_DEPLOYMENT_ENV,
  teamcityEnv: process.env.NEXT_PUBLIC_TEAMCITY_ENV,
  publication: process.env.NEXT_PUBLIC_PUBLICATION,
  useLocalhostApiUrl: process.env.NEXT_PUBLIC_USE_LOCALHOST_API_URL === 'true',
  sentryDebugMode: process.env.NEXT_PUBLIC_SENTRY_DEBUG_MODE === 'true',
  apiUrl: process.env.NEXT_PUBLIC_API_URL,
  authUrl: process.env.NEXT_PUBLIC_AUTH_URL,
  sportApiUrl: process.env.NEXT_PUBLIC_SPORT_API_URL,
  sportApiUrlV2: process.env.NEXT_PUBLIC_SPORT_API_URL_V2,
  lottoUrl: process.env.NEXT_PUBLIC_LOTTO_URL,
  imageUrl: process.env.NEXT_PUBLIC_IMAGE_URL,
  baseUrl: localhostHTTPS
    ? process.env.NEXT_PUBLIC_BASE_URL_HTTPS
    : process.env.NEXT_PUBLIC_BASE_URL,
  staticAssetDomain: useLocalhostStaticPages
    ? process.env.NEXT_PUBLIC_STATIC_ASSET_DOMAIN_LOCALHOST
    : process.env.NEXT_PUBLIC_STATIC_ASSET_DOMAIN,
  staticAssetBaseUrl:
    process.env.NEXT_PUBLIC_DEPLOYMENT_ENV === 'pr' &&
    !process.env.NEXT_PUBLIC_STATIC_PAGE_PR_NUMBER
      ? process.env.NEXT_PUBLIC_FALLBACK_STATIC_ASSET_BASE_URL
      : useLocalhostStaticPages
        ? process.env.NEXT_PUBLIC_STATIC_ASSET_BASE_URL_LOCALHOST
        : process.env.NEXT_PUBLIC_STATIC_ASSET_BASE_URL,
  staticAssetPageUrl:
    process.env.NEXT_PUBLIC_DEPLOYMENT_ENV === 'pr' &&
    !process.env.NEXT_PUBLIC_STATIC_PAGE_PR_NUMBER
      ? process.env.NEXT_PUBLIC_FALLBACK_STATIC_ASSET_PAGE_URL
      : useLocalhostStaticPages
        ? process.env.NEXT_PUBLIC_STATIC_ASSET_PAGE_URL_LOCALHOST
        : process.env.NEXT_PUBLIC_STATIC_ASSET_PAGE_URL,
  staticPageUrlSuffix: useLocalhostStaticPages ? '' : '.html',
  blickTvPlayerAssetUrlPrefix:
    process.env.NEXT_PUBLIC_BLICK_TV_PLAYER_ASSET_URL_PREFIX,
  weatherUrl: process.env.NEXT_PUBLIC_WEATHER_URL,
  chaptersApiUrl: process.env.NEXT_PUBLIC_CHAPTERS_API_URL,
  commentingUrl: process.env.NEXT_PUBLIC_COMMENTING_URL,
  gamificationTrophyUrl: process.env.NEXT_PUBLIC_GAMIFICATION_TROPHY_URL,
  searchUrl: process.env.NEXT_PUBLIC_SEARCH_URL,
  recommendationsUrl: process.env.NEXT_PUBLIC_RECOMMENDATIONS_URL,
  ssoDomain: process.env.NEXT_PUBLIC_SSO_DOMAIN,
  videoMappingUrl: process.env.NEXT_PUBLIC_VIDEO_MAPPING_URL,
  subscriptionCheckerUrl: process.env.NEXT_PUBLIC_SUBSCRIPTION_CHECKER_URL,
  myServicesUrl: process.env.NEXT_PUBLIC_MY_SERVICES_URL,
  ugcUrl: process.env.NEXT_PUBLIC_UGC_URL,
  cueLiveUrl: process.env.NEXT_PUBLIC_CUE_LIVE_URL,
  pianoEnv: process.env.NEXT_PUBLIC_PIANO_ENV,
  plusLinkShareUrl: process.env.NEXT_PUBLIC_PLUS_LINK_SHARE_URL,
  plusSubscriptionServiceUrl:
    process.env.NEXT_PUBLIC_PLUS_SUBSCRIPTION_SERVICE_URL,
  hotModuleReloading: process.env.NEXT_PUBLIC_DEV_SERVER === 'true',
  chatbotChatUrl: process.env.NEXT_PUBLIC_CHATBOT_CHAT_URL,
  chatbotQuestionsUrl: process.env.NEXT_PUBLIC_CHATBOT_QUESTIONS_URL,
  growthBookEnv: process.env.NEXT_PUBLIC_GROWTHBOOK_ENV,
} as EnvVariables

const configItems = {
  abTest,
  appLinks,
  ads,
  auth,
  backend,
  chatbot,
  cmp,
  community,
  cueLive,
  datawrapper,
  date,
  debug,
  dlApi,
  feedback,
  formio,
  gamification,
  gdpr,
  googleNews,
  hearken,
  heimspiel,
  image,
  iframe,
  jwplayer,
  lotto,
  metatags,
  notifications,
  oneSignal,
  piano,
  plusLinkShare,
  prolitteris,
  podigee,
  publication,
  recommendation,
  riddle,
  schema,
  search,
  sentry,
  socialembeds,
  sports,
  subscriptions,
  tracking,
  twitter,
  ugc,
  urlParams,
  usersnap,
  video,
  vimeo,
  weather,
  webarchive,
  zattoo,
  leserreporter,
  textToSpeech,
  articleSummary,
  sectionSummary,
  questionWidget,
  blickBites,
  growthBook,
  aureus,
} as const

export type ConfigType = {
  [key in keyof typeof configItems]: ReturnType<(typeof configItems)[key]>
}

const generatedConfig = Object.entries(configItems).reduce(
  (acc, [configName, configFn]) => {
    acc[configName as keyof typeof configItems] = configFn(rawEnvVariables)
    return acc
  },
  {} as Record<keyof typeof configItems, ReturnType<ConfigFn>>
)

export default generatedConfig as ConfigType
